import {
  USER_LIST_LOADING,
  USER_LIST_SUCCESS,
  USER_LIST_FAILED,
  USER_LIST_CLEAR
} from "../actionTypeConstants/UserList";

const initialState = {
  userList: {
    loading: false,
    data: null,
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_LIST_LOADING:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: true
        }
      };

    case USER_LIST_SUCCESS:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: false,
          data: action.result.data
        }
      };

    case USER_LIST_FAILED:
      return {
        ...state,
        userList: {
          ...state.userList,
          loading: false,
          error: action.error
        }
      };

    case USER_LIST_CLEAR:
      return {
        ...state,
        userList: initialState.userList
      };

    default:
      return state;
  }
}
